module.exports = __webpack_public_path__ + "img/IMG_9621_L_Black_MockedUp.d37f1990.jpg";